export default "__VITE_ASSET__tCTNy6n0__"